import { defineMessages } from '@formatjs/intl';

import {
	MentalHealthSectionTitle,
	MentalHealthSlide,
} from '@/components/homepageRefresh/homepage/MentalHealthTools/types';

export const messages = defineMessages({
	heading: {
		id: 'subpage.stress.mentalHealthTools.heading',
		defaultMessage: 'Stress relief and anxiety tools for real life.',
		description: 'Heading for section with the various mental health tools that Calm provides',
	},
	slide1Title: {
		id: 'subpage.stress.mentalHealthTools.slide1.title',
		defaultMessage: 'Practical Tools',
		description: 'Title for mental health tools slide',
	},
	slide1Heading: {
		id: 'subpage.stress.mentalHealthTools.slide1.heading',
		defaultMessage: 'Get in-the-moment relief',
		description: 'Heading for mental health tools slide',
	},
	slide1Copy: {
		id: 'subpage.stress.mentalHealthTools.slide1.copy',
		defaultMessage:
			'Our clinical experts and mindfulness teachers are here to support you, with a wide range of programs for work stress, acute anxiety, negative thoughts, and more.',
		description: 'Copy for mental health tools slide',
	},
	slide1ContentTitle: {
		id: 'subpage.stress.mentalHealthTools.slide1.contentTitle',
		defaultMessage: 'Overcome Stress and Anxiety',
		description: "Title of slide's previewable content",
	},
	slide1ContentSubheading: {
		id: 'subpage.stress.mentalHealthTools.slide1.contentSubheading',
		defaultMessage: '11 tools to reclaim your calm',
		description: "Information for slide's previewable content",
	},
	slide1ContentAuthor: {
		id: 'subpage.stress.mentalHealthTools.slide1.contentAuthor',
		defaultMessage: 'Narrated by Dr. Julie Smith',
		description: "Author of slide's previewable content",
	},
	slide2Title: {
		id: 'subpage.stress.mentalHealthTools.slide2.title',
		defaultMessage: 'Quick Relief',
		description: 'Title for mental health tools slide',
	},
	slide2Heading: {
		id: 'subpage.stress.mentalHealthTools.slide2.heading',
		defaultMessage: 'Feel better in just a few minutes',
		description: 'Heading for mental health tools slide',
	},
	slide2Copy: {
		id: 'subpage.stress.mentalHealthTools.slide2.copy',
		defaultMessage:
			'Sometimes you just need a quick dose of Calm. Choose from a range of tools to manage everyday stressors, including breathing exercises and mindfulness practices.',
		description: 'Copy for mental health tools slide',
	},
	slide2ContentTitle: {
		id: 'subpage.stress.mentalHealthTools.slide2.contentTitle',
		defaultMessage: 'Relax Your Mind',
		description: "Title of slide's previewable content",
	},
	slide2ContentSubheading: {
		id: 'subpage.stress.mentalHealthTools.slide2.contentSubheading',
		defaultMessage: 'Drop into this moment to ease your mind',
		description: "Information for slide's previewable content",
	},
	slide2ContentAuthor: {
		id: 'subpage.stress.mentalHealthTools.slide2.contentAuthor',
		defaultMessage: 'Narrated by Jeff Warren',
		description: "Author of slide's previewable content",
	},
	slide3Title: {
		id: 'subpage.stress.mentalHealthTools.slide3.title',
		defaultMessage: 'Grounding Exercises',
		description: 'Title for mental health tools slide',
	},
	slide3Heading: {
		id: 'subpage.stress.mentalHealthTools.slide3.heading',
		defaultMessage: 'Bring yourself back to the present moment',
		description: 'Heading for mental health tools slide',
	},
	slide3Copy: {
		id: 'subpage.stress.mentalHealthTools.slide3.copy',
		defaultMessage:
			"When overwhelm sets in, reach for one of Calm's grounding exercises. These short guided sessions use sensation, movement, and breath work to help you relax and reset.",
		description: 'Copy for mental health tools slide',
	},
	slide3ContentTitle: {
		id: 'subpage.stress.mentalHealthTools.slide3.contentTitle',
		defaultMessage: 'Ground Yourself in the Body',
		description: "Title of slide's previewable content",
	},
	slide3ContentSubheading: {
		id: 'subpage.stress.mentalHealthTools.slide3.contentSubheading',
		defaultMessage: 'A short practice to anchor yourself amidst overwhelm',
		description: "Information for slide's previewable content",
	},
	slide3ContentAuthor: {
		id: 'subpage.stress.mentalHealthTools.slide3.contentAuthor',
		defaultMessage: 'Narrated by Jay Shetty',
		description: "Author of slide's previewable content",
	},
	slide4Title: {
		id: 'subpage.stress.mentalHealthTools.slide4.title',
		defaultMessage: 'Breath Work',
		description: 'Title for mental health tools slide',
	},
	slide4Heading: {
		id: 'subpage.stress.mentalHealthTools.slide4.heading',
		defaultMessage: 'Connect with the calming power of the breath',
		description: 'Heading for mental health tools slide',
	},
	slide4Copy: {
		id: 'subpage.stress.mentalHealthTools.slide4.copy',
		defaultMessage:
			'Your breath can support you, and our meditation teachers will show you how. Learn evidence-based breathwork techniques to soften anxiety, release tension, and sharpen focus.',
		description: 'Copy for mental health tools slide',
	},
	slide4ContentTitle: {
		id: 'subpage.stress.mentalHealthTools.slide4.contentTitle',
		defaultMessage: 'SOS Breath Work',
		description: "Title of slide's previewable content",
	},
	slide4ContentSubheading: {
		id: 'subpage.stress.mentalHealthTools.slide4.contentSubheading',
		defaultMessage: 'A breathing practice to help relieve stress',
		description: "Information for slide's previewable content",
	},
	slide4ContentAuthor: {
		id: 'subpage.stress.mentalHealthTools.slide4.contentAuthor',
		defaultMessage: 'Narrated by Chibs Okereke',
		description: "Author of slide's previewable content",
	},
	slide5Title: {
		id: 'subpage.stress.mentalHealthTools.slide5.title',
		defaultMessage: 'Courses',
		description: 'Title for mental health tools slide',
	},
	slide5Heading: {
		id: 'subpage.stress.mentalHealthTools.slide5.heading',
		defaultMessage: 'Step-by-step guidance to ease your stress',
		description: 'Heading for mental health tools slide',
	},
	slide5Copy: {
		id: 'subpage.stress.mentalHealthTools.slide5.copy',
		defaultMessage:
			"In just 10 minutes a day, you'll learn how to manage your stress and anxiety symptoms. Choose from many popular courses, like 7 Days of Calming Anxiety and 7 Days of Managing Stress.",
		description: 'Copy for mental health tools slide',
	},
	slide5ContentTitle: {
		id: 'subpage.stress.mentalHealthTools.slide5.contentTitle',
		defaultMessage: '7 Days of Calming Anxiety',
		description: "Title of slide's previewable content",
	},
	slide5ContentSubheading: {
		id: 'subpage.stress.mentalHealthTools.slide5.contentSubheading',
		defaultMessage: 'A breathing meditation to help relieve feelings of anxiety and tension',
		description: "Information for slide's previewable content",
	},
	slide5ContentAuthor: {
		id: 'subpage.stress.mentalHealthTools.slide5.contentAuthor',
		defaultMessage: 'Narrated by Tamara Levitt',
		description: "Author of slide's previewable content",
	},
});

export const sections: Record<MentalHealthSectionTitle, MentalHealthSlide> = {
	practicalTools: {
		title: messages.slide1Title,
		heading: messages.slide1Heading,
		copy: messages.slide1Copy,
		contentTitle: messages.slide1ContentTitle,
		contentSubheading: messages.slide1ContentSubheading,
		contentUrl: '/app/player/_S2rPcb7eB',
		author: messages.slide1ContentAuthor,
		imageUrl: '/_n/images/subpages/stress-player-stress.webp',
		audioSrc: 'https://assets.calm.com/16cc1921a647c99a766bdba9bd8177e8.m4a',
	},
	quickRelief: {
		title: messages.slide2Title,
		heading: messages.slide2Heading,
		copy: messages.slide2Copy,
		contentTitle: messages.slide2ContentTitle,
		contentSubheading: messages.slide2ContentSubheading,
		contentUrl: '/app/player/ucDaO61DrR',
		author: messages.slide2ContentAuthor,
		imageUrl: '/_n/images/subpages/stress-player-relief.webp',
		audioSrc: 'https://assets.calm.com/3923d44749d00e878779fe6ec5be76e3.m4a',
	},
	groundingExercises: {
		title: messages.slide3Title,
		heading: messages.slide3Heading,
		copy: messages.slide3Copy,
		contentTitle: messages.slide3ContentTitle,
		contentSubheading: messages.slide3ContentSubheading,
		author: messages.slide3ContentAuthor,
		contentUrl: '/app/player/P70auH0MAt',
		imageUrl: '/_n/images/subpages/stress-player-grounding.webp',
		audioSrc: 'https://assets.calm.com/c15726a5572712dcfc251677cf198002.m4a',
	},
	breathwork: {
		title: messages.slide4Title,
		heading: messages.slide4Heading,
		copy: messages.slide4Copy,
		contentTitle: messages.slide4ContentTitle,
		contentSubheading: messages.slide4ContentSubheading,
		author: messages.slide4ContentAuthor,
		contentUrl: '/app/player/9ikRv2slmt',
		imageUrl: '/_n/images/subpages/stress-player-breathwork.webp',
		audioSrc: 'https://assets.calm.com/a9d81d71a7f6677c9737ceb869052f6d.m4a',
	},
	courses: {
		title: messages.slide5Title,
		heading: messages.slide5Heading,
		copy: messages.slide5Copy,
		contentTitle: messages.slide5ContentTitle,
		contentSubheading: messages.slide5ContentSubheading,
		author: messages.slide5ContentAuthor,
		contentUrl: '/app/player/MdzQdKmy9',
		imageUrl: '/_n/images/subpages/stress-player-courses.webp',
		audioSrc:
			'/_n/audio/subpages/MSER_0009_01_LettingGoOfAnxietyDay1ThePresent_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
};
